import Drawer from "@mui/material/Drawer";
import BaseButton from "../BaseButton";
import CloseIcon from "@mui/icons-material/Close";

const BaseDrawer = ({
  open,
  onClose,
  onApply,
  isLoading = false,
  width = 530,
  title = "",
  children,
  saveButtonText = "Save",
  enabled = false,
  isShowButton = true,
  handleResetFilters,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      onKeyDown={(e) => {
        if (e.key === "Enter" && enabled && !isLoading) onApply();
      }}
      PaperProps={{
        sx: {
          width: `${width}px`,
          borderTopLeftRadius: 6,
          borderBottomLeftRadius: 6,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <div className="relative flex-shrink-0 border-b p-4">
        <button
          onClick={onClose}
          className="absolute top-2 right-0 m-2  hover:text-black text-gray-600 cursor-pointer"
        >
          <CloseIcon className="text-2xl" />
        </button>
        {title && <h2 className="text-lg font-medium pr-10">{title}</h2>}
      </div>

      <div className="flex-1 overflow-y-auto p-5">{children}</div>

      {isShowButton && (
        <div
          className="flex-shrink-0 flex items-center justify-center bg-white py-6"
          style={{
            boxShadow: "5px 0px 14px 5px rgba(0, 0, 0, 0.07)",
          }}
        >
          <BaseButton
            className="py-[5px] px-2 ml-4 bg-[#F3F3F3]"
            // className="py-[5px] px-4 bg-white text-blue-600 border-10 border-blue-600"
            style={{
              border: "2px solid #0F40AE", // primary color
              color: "#0F40AE", // primary text
              backgroundColor: "white",
            }}
            fullWidth={false}
            onClick={handleResetFilters} // call reset filters function
          >
            Reset Filters
          </BaseButton>
          <BaseButton
            className="py-[5px] px-4 ml-4 bg-[#E8E8E8] text-dark"
            fullWidth={false}
            onClick={onClose}
          >
            <p>Cancel</p>
          </BaseButton>
          <BaseButton
            isLoading={isLoading}
            disabled={isLoading || !enabled}
            className="py-[5px] px-4 ml-4"
            color="primary"
            fullWidth={false}
            onClick={onApply}
          >
            {saveButtonText}
          </BaseButton>
        </div>
      )}
    </Drawer>
  );
};

export default BaseDrawer;
